import { render, staticRenderFns } from "./ManualOrderTypes.vue?vue&type=template&id=0dd6cbb1&scoped=true&"
import script from "./ManualOrderTypes.vue?vue&type=script&lang=js&"
export * from "./ManualOrderTypes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0dd6cbb1",
  null
  
)

export default component.exports